export interface FilterOption {
  label: string
  value?: string
}

// Prepend a sentinel "all" option (value undefined → filter omitted) and coerce
// option values to strings for the action-sheet select.
export const withAllOption = (
  options: { label: string; value: string | number }[],
  allLabel: string
): FilterOption[] => [
  { label: allLabel, value: undefined },
  ...options.map((o) => ({ label: o.label, value: String(o.value) })),
]

/**
 * SN-8309 — the Player Finder's gender filter: the real genders only. Its
 * default, "All Eligible Genders", sends nothing, and the server then applies
 * the competition's own gender rule; the profile form's client-only
 * "Unspecified" sentinel has no meaning here and is not offered.
 */
export const finderGenderOptions = (
  genders: readonly { label: string; value: string }[],
  unspecifiedValue: string
): { label: string; value: string }[] =>
  genders.filter((option) => option.value !== unspecifiedValue)
